<template>
  <Modal :show="show" @update:show="(val: boolean) => emit('update:show', val)" @closed="handleClosed">
    <div class="container">
      <Tabs class="wrapper-tab" scene="pure" size="normal" v-model:active="activesTabs['0']" :items="[
        { title: '专家评审奖通道', name: 'expertReview' },
        { title: '快手人气奖通道', name: 'kuaishouPopularity' },
      ]">
      <div style="width: 100%; height: 1px; background-color: #fff;"></div>
        <template #expertReview>
          <div class="content-box">
            <SubmitForm v-model="info.expertReview" :items="datas?.expertReview ?? []" :topics="topics" />
          </div>
        </template>
        <template #kuaishouPopularity>
          <div class="content-box">
            <SubmitForm v-model="info.kuaishouPopularity" :topics="topics" />
          </div>
        </template>
      </Tabs>
      <div class="bottom-btn">
        <div class="box">
          <Button size="large" class="contribute" @click="handleSubmit" :disabled="isDisabledBtn">立即投稿</Button>
          <span v-show="activesTabs[0] === 'expertReview' && activeItem" class="tips">
            "{{ activeItem?.title }}"剩余投稿次数：{{
              activeItem?.restSubmitCount
            }}
          </span>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
import Button from "../common/button.vue";
import Modal from "../common/modal.vue";
import Tabs from "../common/tabs.vue";
import SubmitForm from "./submitForm.vue";
import {
  SubmitContributeParams,
  getContributeCount,
  getPageUI,
  submitContribute,
} from "../common/api/request";
import { cloneDeep } from "lodash-es";
import { ApiModal } from "#imports";
import ToastModal from "../modal/toastModal.vue";
import checkPermission, { checkAuth } from "../checkPermission";
import kylogger from "@ky/sdk/dist/log/kylogger";
import RaceModal from "../modal/raceModal.vue";
export interface FormModalProps {
  show?: boolean;
  actives?: ["expertReview" | "kuaishouPopularity", string | number];
}
const raceModal = ref<ApiModal<any>>();
type Event = {
  (e: "update:show", show: boolean): void;
  (e: "update:count", data: any): void;
};

const topics = ref<string[]>([]);

const props = withDefaults(defineProps<FormModalProps>(), {
  actives: () => ["expertReview", 0] as NonNullable<FormModalProps["actives"]>,
});
const emit = defineEmits<Event>();
const isSubmiting = ref(false);

const initialInfo: {
  expertReview: SubmitContributeParams;
  kuaishouPopularity: SubmitContributeParams;
} = {
  expertReview: {
    contestChannel: "expertReview",
    secondContestChannel: 1,
    photoUrl: "",
    photoTitle: "",
    photoDescription: "",
  },
  kuaishouPopularity: {
    contestChannel: "kuaishouPopularity",
    secondContestChannel: 0,
    photoUrl: "",
    photoTitle: "",
    photoDescription: "",
  },
};

const info = ref(cloneDeep(initialInfo));
const toastModal = ref<ApiModal<typeof ToastModal>>();

const activesTabs = ref(props.actives);

const datas = ref<Awaited<ReturnType<typeof getContributeCount>>["data"]>();

const activeItem = computed(() => {
  const [type, name] = activesTabs.value ?? [];
  if (type === "expertReview") {
    const code = info.value.expertReview.secondContestChannel;
    return datas.value?.expertReview?.find((item) => item.code === code);
  } else {
    return datas.value?.kuaishouPopularity?.[0];
  }
});

watchEffect(() => {
  const actives = cloneDeep(props?.actives);
  if (actives?.[0] === "expertReview") {
    const item =
      datas.value?.expertReview?.find((item) => item.code === actives?.[1]) ??
      datas.value?.expertReview?.[0];
    actives[1] = item?.code!;
  }
  activesTabs.value = actives;
});

watch(activesTabs, (value) => {
  if (value[0] === "expertReview") {
    info.value.expertReview.secondContestChannel = +value[1]!;
  }
});

const handleClosed = () => {
  info.value = cloneDeep(initialInfo);
};
const handleContribute = async () => {
  kylogger.collect("CLICK", "SUBMIT_NOW", {});

  await checkAuth();
  if (!raceModal.value) {
    raceModal.value = new ApiModal(RaceModal);
  }
  raceModal.value.show();
};
const handleSubmit = async () => {
  await checkPermission();
  const active = activesTabs.value?.[0];
  const params = info.value?.[active as keyof typeof info.value];
  console.log("...", params);
  kylogger.collect("CLICK", "SUBMIT_TO_TRACK", {
    track: params.secondContestChannel,
  });
  if (!params) return;
  isSubmiting.value = true;
  submitContribute(params!)
    .then(() => {
      toastModal.value?.show({
        type: "success",
        toastSmall: false,
        //@ts-ignore
        onConfirm: () => {
          handleContribute();
        },
      });
      emit("update:show", false);
      updateCount();
      info.value = cloneDeep(initialInfo);
    })
    .finally(() => {
      isSubmiting.value = false;
    });
};

const updateCount = async () => {
  getContributeCount().then((data) => {
    datas.value = data.data;
    emit("update:count", data.data);
  });
};

const isDisabledBtn = computed(() => {
  if (isSubmiting.value) return true;
  const active = activesTabs.value?.[0];
  const params = info.value?.[active as keyof typeof info.value];
  if (!params) return true;
  return !params.photoUrl || !params.photoTitle || !params.photoDescription;
});

watch(
  () => props.show,
  (value) => {
    if (!value) return;
    getPageUI().then((uiData) => {
      topics.value = uiData?.data?.topics!;
    });
    getContributeCount().then((data) => {
      datas.value = data.data;
    });
  },
  { immediate: true },
);

onMounted(() => {
  toastModal.value = new ApiModal(ToastModal);
  kylogger.collect("SHOW", "SUBMIT_POPUP", {});
});
</script>

<style scoped lang="less">
.container {
  --kling-bottom-padding: 2.48rem;
  --kling-safe-area-inset-bottom: env(safe-area-inset-bottom);
  width: 11.2rem;
  min-height: 14.52rem;
  position: relative;
  padding-top: 0.48rem;
  padding-bottom: var(--kling-bottom-padding);
  background-color: rgba(26, 27, 34, 1);
  .wrapper-tab {
    padding-top: 0rem;
    justify-content: center;

    :deep(.van-tabs) {
      &__content {
        @media screen and (max-width: 1360px) {
          padding-top: 0rem;
          overflow-y: auto;
          :deep(.van-tabs__wrap) {
            justify-content: flex-start;
          }

          :deep(.van-popup__close-icon) {
            padding-top: 0.2rem;
          }
        }
      }
    }

    :deep(.van-tabs__nav--line) {
      margin-left: 0.16rem;
    }
  }

  @media screen and (max-width: 1360px) {
    --kling-bottom-padding: 1.88rem;
    width: 100vw;
    padding-top: 0.12rem;
    height: calc(100vh - var(--safe-area-top) - 1rem);
    min-height: 0;
    overflow: hidden;
  }

  .content-box {
    padding: 0.44rem 0.6rem 0.6rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: 1360px) {
      margin-bottom: 1.5rem;
      padding: 0.4rem 0.32rem;
      height: calc(100vh - 0.96rem - 1.82rem);
    }

    .style-tabs {
      width: 100%;
      overflow-x: auto;

      :deep(.van-tabs) {
        &__wrap {
          margin-bottom: 0.44rem;
        }
      }
    }
  }

  .bottom-btn {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(0.3rem + var(--kling-bottom-padding));
    background: var(--kling-modal-background);
    padding: 0.04rem 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: calc(0.48rem + var(--kling-safe-area-inset-bottom));

    @media screen and (max-width: 1360px) {
      position: fixed;
      padding-top: 0.6rem;
      padding-bottom: calc(0.26rem + var(--kling-safe-area-inset-bottom));
    }

    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 1360px) {
        .contribute {
          padding: 0 0.98rem;
          height: 0.88rem;
          font-size: 0.3rem;
          font-weight: 500;
          line-height: 0.42rem;
        }
      }
    }

    .tips {
      font-size: 0.2rem;
      margin-top: 0.24rem;
      color: rgba(255, 255, 255, 0.5);
    }
  }
}
</style>
